import { memo } from 'react'

import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

export const FirstLoginSuccesfullyIllustration = memo(() => (
  <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
    <G clipPath="url(#clip0_8483_162493)">
      <Path
        d="M49.6402 56.99C48.1702 55.84 49.0602 53.71 50.8602 54.22C48.9702 51.77 51.4702 50.86 52.6102 51.19C51.1202 50.3 51.2802 47.5 54.1102 47.99C54.1102 47.99 52.3802 45.23 55.7602 45.23C56.4102 45.23 57.9802 46.61 57.9802 46.61C57.9802 46.61 58.4602 45.83 58.6902 45.63C59.4402 44.98 63.3002 46.85 64.2802 48.01C64.9402 48.8 65.6602 50.81 65.8302 51.82C66.1102 53.44 67.3502 54.09 67.6702 54.94C68.7202 57.74 63.4802 65.08 62.8502 65.02C62.8502 65.02 60.3902 63.6 59.3902 63.55C54.6502 63.29 50.7802 58.16 50.7802 58.16C50.7802 58.16 49.9602 57.23 49.6402 56.98V56.99Z"
        fill="#F5F5F5"
      />
      <Path
        d="M164.33 106.59C164.06 104.26 163 102.08 161.33 100.43C159.65 98.78 157.46 97.75 155.12 97.52L129.77 94.41V94.39C130 92.83 130.15 91.27 130.19 89.7C130.22 88.93 130.23 88.15 130.21 87.36C130.2 86.76 130.17 86.16 130.13 85.54C130.12 85.39 130.11 85.24 130.09 85.08C130.08 84.87 130.06 84.67 130.04 84.46C130.04 84.45 130.04 84.43 130.03 84.42C130.03 84.38 130.02 84.33 130.01 84.28C129.77 82.38 129.43 80.49 128.99 78.63C128.17 75.15 127.01 71.76 125.52 68.5C125.5 68.5 125.49 68.53 125.47 68.54C124.67 69.27 123.74 69.85 122.72 70.22C122.9 70.66 123.08 71.1 123.24 71.55C123.48 72.18 123.7 72.81 123.91 73.45C123.91 73.46 123.92 73.47 123.92 73.48C124.75 75.99 125.39 78.56 125.82 81.17C125.82 81.19 125.83 81.22 125.83 81.24L115.52 82.35V82.31C115.48 81.84 115.41 81.32 115.34 80.76C114.98 77.58 114.34 74.44 113.45 71.35H113.44C112.29 71.53 111.13 71.4 109.99 71.16C109.99 71.16 109.99 71.18 110 71.22C110 71.22 110.01 71.29 110.03 71.34C110.04 71.39 110.05 71.46 110.08 71.54V71.56C110.15 71.79 110.23 72.11 110.31 72.5C110.43 73.01 110.57 73.66 110.73 74.4C110.8 74.68 110.86 74.98 110.92 75.29C110.99 75.67 111.06 76.06 111.14 76.46C111.19 76.75 111.25 77.04 111.3 77.34C111.42 78.04 111.54 78.78 111.64 79.52C111.72 80.07 111.79 80.63 111.85 81.18C111.89 81.55 111.92 81.92 111.95 82.28C111.97 82.55 111.99 82.82 112 83.09C112.01 83.22 112.02 83.35 112.02 83.48C112.03 83.61 112.03 83.74 112.03 83.87C112.04 84.28 112.04 84.69 112.02 85.08C112.02 85.17 112.01 85.26 112.01 85.35C112 85.57 111.98 85.78 111.96 85.98C111.93 86.22 111.9 86.45 111.87 86.67C111.82 86.93 111.76 87.17 111.7 87.39C111.66 87.52 111.61 87.64 111.57 87.76C111.53 87.87 111.48 87.98 111.44 88.07C110.94 89.1 110.07 89.5 108.67 88.86H108.66L109.57 96.47V96.51C108.64 97.32 107.42 99.03 106.21 101.31C105.92 101.84 105.65 102.4 105.38 102.99C105.27 103.22 105.17 103.45 105.07 103.68C104.96 103.91 104.86 104.15 104.76 104.39C104.65 104.65 104.54 104.9 104.44 105.17C104.33 105.45 104.22 105.74 104.11 106.03C103.99 106.33 103.88 106.65 103.77 106.97C103.62 107.39 103.47 107.82 103.34 108.26C103.06 109.14 102.8 110.04 102.58 110.97C102.47 111.43 102.36 111.9 102.26 112.37C102.19 112.67 102.13 112.97 102.08 113.28C101.97 113.89 101.87 114.51 101.78 115.13C101.61 116.36 101.51 117.6 101.48 118.85V118.9C95.4102 135.99 86.9802 155.4 77.4902 175.86C77.4902 175.87 77.4902 175.89 77.4702 175.9C78.1902 176.4 78.9202 176.88 79.6602 177.33C80.8102 178.04 81.9802 178.68 83.1802 179.24C83.7802 179.53 84.3902 179.8 85.0102 180.03C85.2502 180.12 85.4802 180.21 85.7202 180.3C85.8502 180.35 85.9902 180.4 86.1202 180.45C86.1902 180.47 86.2602 180.49 86.3202 180.52C86.3402 180.53 86.3502 180.53 86.3702 180.54C86.3802 180.55 86.4002 180.56 86.4102 180.56C86.4102 180.56 86.4169 180.56 86.4302 180.56C86.7702 180.68 87.1102 180.79 87.4502 180.9C87.7102 180.98 87.9702 181.06 88.2202 181.13C89.0002 181.35 89.7902 181.54 90.5802 181.68C90.7102 181.71 90.8402 181.73 90.9702 181.75C91.1002 181.77 91.2302 181.79 91.3602 181.81C91.4002 181.83 91.4502 181.83 91.5002 181.83C91.7402 181.87 91.9802 181.9 92.2202 181.93C92.5302 181.97 92.8402 182 93.1502 182.03C93.8602 182.09 94.5802 182.12 95.3102 182.12C96.6902 179.4 98.0402 176.67 99.3802 173.93C100.5 171.64 101.61 169.33 102.71 167.02C103.43 165.52 104.14 164.02 104.84 162.51C105.44 161.23 106.03 159.96 106.62 158.68C107.46 156.88 108.28 155.07 109.1 153.25C109.67 151.99 110.24 150.72 110.8 149.45C111.41 148.07 112.02 146.69 112.62 145.3C113.09 144.23 113.56 143.15 114.02 142.07C114.73 140.41 115.43 138.75 116.13 137.09C116.71 135.73 117.27 134.38 117.83 133.03C120.29 127.14 122.65 121.22 124.93 115.27C132.18 116.15 139.51 116.01 146.73 114.86C147.51 122.92 149.06 131.55 151.07 141.91C151.64 142 152.2 142.08 152.74 142.15C154.12 142.34 155.39 142.49 156.6 142.55C156.77 142.56 156.94 142.57 157.11 142.58C157.71 142.61 158.3 142.62 158.88 142.6C159.12 142.6 159.35 142.59 159.58 142.57C159.73 142.57 159.87 142.55 160.02 142.54C162.64 142.32 165.12 141.55 167.98 139.91L164.33 106.59ZM122.08 95.82L116.59 94.39L115.93 85.48L126.45 84.46L126.78 93.32L122.08 95.82Z"
        fill="#F3123C"
      />
      <Path
        d="M97.25 204.09C97.28 204.44 97.22 204.78 97.07 205.1C96.93 205.41 96.7 205.67 96.41 205.86C96.12 206.06 95.79 206.17 95.44 206.18H95.37C94.95 206.21 94.52 206.22 94.1 206.23C93.21 206.26 92.31 206.26 91.42 206.23C90.08 206.2 88.75 206.11 87.41 205.97H87.4C86.71 205.89 86.05 205.67 85.45 205.31C85.16 205.14 84.89 204.93 84.64 204.69C84.39 204.45 84.17 204.19 83.97 203.9C83.33 203.14 82.64 202.11 81.92 200.95C81.62 200.49 81.33 200 81.03 199.5C79.72 197.28 78.37 194.88 77.18 193.21C75.87 191.39 73.43 188.84 73.8 187.18C74.1 185.91 77.59 182.6 78.42 181.17V181.16C79.19 182.16 80.04 183.09 80.95 183.95C83.72 186.51 87.09 188.36 90.78 189.3V189.32C90.51 191.73 90.65 194.17 91.21 196.52C91.21 196.54 91.21 196.56 91.21 196.57C91.34 197.1 91.48 197.63 91.65 198.15C91.95 198.4 92.22 198.62 92.47 198.83C92.54 198.89 92.61 198.95 92.68 199C92.7 199.02 92.71 199.03 92.73 199.04C93.63 199.78 94.25 200.27 94.78 200.75C94.82 200.79 94.86 200.83 94.91 200.87C95.56 201.47 96.07 202.07 96.86 203.14C97.06 203.42 97.19 203.75 97.22 204.09H97.25Z"
        fill="#404040"
      />
      <Path
        d="M183.7 162.09C183.61 162.37 183.43 162.62 183.19 162.81C182.95 162.99 182.65 163.09 182.35 163.1C171.79 163.09 163.04 162.97 154.61 162.96C154.49 162.96 154.36 162.95 154.23 162.92C154.15 162.9 154.07 162.88 153.99 162.85C153.95 162.84 153.91 162.83 153.87 162.81C153.64 162.7 153.43 162.55 153.25 162.37C153.08 162.17 152.95 161.95 152.86 161.71C152.78 161.47 152.74 161.21 152.76 160.96C152.79 160.57 152.82 160.19 152.86 159.8C152.96 158.86 153.1 157.92 153.29 157C153.39 156.52 153.5 156.04 153.61 155.57C153.75 155.04 153.89 154.51 154.05 153.99C154.17 153.59 154.3 153.19 154.44 152.8C154.44 152.8 154.45 152.8 154.44 152.79C154.44 152.79 154.443 152.783 154.45 152.77C154.73 152.85 155.01 152.93 155.29 152.99C159.24 153.97 163.38 153.97 167.33 152.99C167.61 152.93 167.89 152.85 168.17 152.77C169.02 153.02 169.95 153.33 170.93 153.69C171.58 153.94 172.25 154.21 172.93 154.49C176.66 156.07 180.67 158.26 183.17 160.49C183.23 160.53 183.29 160.58 183.34 160.64C183.51 160.8 183.62 160.99 183.69 161.2C183.78 161.49 183.78 161.8 183.69 162.09H183.7Z"
        fill="#404040"
      />
      <Path
        d="M62.65 65.34C62.59 65.39 62.53 65.44 62.48 65.47C62.38 65.55 62.28 65.63 62.18 65.69C61.21 66.33 60.51 66.37 60.22 66.27C60.21 66.27 60.21 66.26 60.2 66.26C60.19 66.26 60.19 66.26 60.18 66.26C60.18 66.26 60.18 66.26 60.16 66.26C59.7 66.02 59.56 65.37 59.68 64.46C59.69 64.36 59.71 64.26 59.73 64.15C59.75 64.04 59.77 63.93 59.8 63.82C59.81 63.81 59.81 63.8 59.81 63.79C60.14 63.95 60.54 64.16 60.93 64.38C61.51 64.68 62.08 65 62.63 65.34H62.64L62.65 65.35V65.34Z"
        fill="#404040"
      />
      <Path
        d="M67.9999 54.3C67.9999 54.51 67.9899 54.72 67.9699 54.94C67.5599 54.69 67.1999 54.36 66.8999 53.99C66.8699 53.94 66.8299 53.9 66.7999 53.85C66.5399 53.51 66.3399 53.13 66.1899 52.73C66.6899 52.43 67.0899 52.4 67.3799 52.56C67.3999 52.56 67.4199 52.58 67.4399 52.59C67.8199 52.85 68.0099 53.48 67.9999 54.3Z"
        fill="#404040"
      />
      <Path
        d="M119.84 55.27C119.78 55.2 119.73 55.13 119.66 55.07C117.98 53.11 116.58 53.28 115.59 54.35C115.41 54.55 115.25 54.77 115.1 55.01C114.87 55.38 114.68 55.8 114.53 56.24C114.37 56.67 114.25 57.14 114.17 57.6C114.04 58.37 114.02 59.14 114.11 59.79C114.11 59.84 114.11 59.89 114.11 59.94C114.11 60.11 114.09 60.24 114.03 60.33C114.02 60.35 114 60.37 113.98 60.38C113.96 60.41 113.93 60.42 113.9 60.43C113.78 60.49 113.61 60.47 113.35 60.37C113.17 60.3 112.97 60.19 112.76 60.07C112.06 59.65 111.52 59.73 111.23 60.07C110.86 60.49 110.89 61.34 111.52 62.18C111.62 62.32 111.75 62.46 111.89 62.59C112.36 63.06 113.05 63.49 113.99 63.81C114.16 64.32 114.32 64.84 114.45 65.37C114.57 65.87 114.68 66.36 114.78 66.86C114.78 66.88 114.78 66.9 114.78 66.92C114.7 66.68 114.61 66.45 114.51 66.25C114.35 65.93 114.15 65.66 113.93 65.43C111.99 63.36 108 64.49 105.35 65.36C105.07 65.45 104.81 65.54 104.56 65.62C104.19 65.74 103.87 65.84 103.6 65.92C101.99 66.38 100.74 66.68 100.15 66.2C100.07 66.14 100.01 66.07 99.9599 65.99C99.8999 65.9 99.8599 65.79 99.8299 65.68C99.7799 65.48 99.7799 65.26 99.8199 65.02C99.8499 64.81 99.9199 64.59 100.03 64.37C100.19 64.03 100.43 63.69 100.77 63.38C100.98 63.16 101.24 62.96 101.53 62.78H101.54C102 62.5 102.49 62.26 103.02 62.08C101.94 62.43 101.04 62.37 100.7 61.83C100.52 61.54 100.54 61.1 100.72 60.63C100.91 60.12 101.28 59.57 101.79 59.08C102.05 58.83 102.33 58.6 102.65 58.39C102.71 58.36 102.85 58.28 102.98 58.2L103.18 58.09C103.18 58.09 103.23 58.06 103.26 58.05L103.3 58.02C102.41 58.24 101.82 58.14 101.5 57.85C100.91 57.34 101.19 56.2 102.15 55.22C102.22 55.14 102.29 55.07 102.37 55C102.82 54.59 103.4 54.21 104.08 53.93C104.31 53.83 104.55 53.74 104.77 53.65C105.23 53.48 105.66 53.32 106.09 53.16C110.56 51.62 113.56 51.59 115.62 52.19C116.01 52.3 116.36 52.44 116.69 52.59C116.96 52.71 117.2 52.84 117.43 52.98C118.04 53.36 118.53 53.79 118.93 54.21C119.11 54.4 119.27 54.59 119.42 54.77C119.57 54.95 119.7 55.12 119.82 55.28L119.84 55.27Z"
        fill="#404040"
      />
      <Path
        d="M120.58 69.03C120.58 69.03 120.55 69.02 120.54 69.01C119.5 68.43 118.52 67.74 117.62 66.96C117.62 66.96 117.6 66.95 117.59 66.94C118.44 67 119.31 66.96 120.15 66.79V66.82C120.15 67 120.16 67.18 120.18 67.37V67.39C120.23 67.95 120.37 68.5 120.58 69.03Z"
        fill="#404040"
      />
      <Path
        d="M97.2399 204.09C97.2699 204.43 97.2099 204.78 97.0599 205.09C96.9099 205.4 96.6799 205.66 96.3899 205.85C96.0999 206.04 95.7699 206.15 95.4199 206.16V206.18H95.37C95.15 206.19 94.9199 206.2 94.6999 206.21C94.5599 206.22 94.4299 206.23 94.2899 206.23H94.0999C93.0999 206.27 92.1099 206.27 91.0999 206.23C90.9699 206.23 90.8299 206.22 90.6999 206.21C90.2699 206.2 89.84 206.17 89.41 206.14C89.34 206.14 89.2599 206.14 89.1799 206.12C88.5899 206.09 88 206.03 87.41 205.97H87.3999C86.7099 205.89 86.0499 205.67 85.4499 205.31C85.1599 205.14 84.8899 204.93 84.6399 204.69C84.3899 204.46 84.1599 204.19 83.9599 203.9C83.6399 203.53 83.3099 203.08 82.9699 202.58C82.9599 202.58 82.9699 202.57 82.9699 202.57C82.7999 202.33 82.6299 202.07 82.4499 201.79C82.2699 201.52 82.0999 201.24 81.9199 200.95C81.6199 200.49 81.3299 200 81.0299 199.5C80.6999 198.95 80.3699 198.38 80.0399 197.82C79.0399 196.13 78.05 194.46 77.16 193.21C75.86 191.38 73.3999 188.84 73.7899 187.18C73.9399 186.54 74.8799 185.4 75.9099 184.23C76.1599 183.93 76.4199 183.63 76.6699 183.35C77.4299 182.49 78.11 181.68 78.41 181.15H78.4199V181.17C78.6099 181.42 78.8099 181.66 79.0199 181.9C79.4299 182.38 79.8499 182.84 80.2899 183.29C80.4999 183.51 80.7299 183.73 80.9599 183.95C83.7299 186.51 87.0999 188.36 90.7899 189.3C90.5699 191.02 90.53 194.18 91.23 196.52C91.23 196.54 91.23 196.56 91.23 196.57C91.52 197.51 91.9199 198.31 92.4899 198.83C92.5299 198.87 92.5699 198.91 92.6099 198.94C92.6399 198.96 92.6699 198.98 92.6999 199C92.7199 199.02 92.7299 199.03 92.7499 199.04C93.3199 199.45 93.8599 199.89 94.3799 200.38C94.5199 200.48 94.66 200.62 94.8 200.75C94.84 200.79 94.8799 200.83 94.9299 200.87C95.6299 201.57 96.2799 202.33 96.8599 203.14C97.0699 203.42 97.19 203.75 97.23 204.09H97.2399Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M93.1499 182.03C91.9899 184.31 91.1899 186.77 90.7999 189.3C87.1099 188.36 83.7399 186.51 80.9699 183.95C80.0599 183.09 79.2099 182.16 78.4399 181.16C79.0199 179.96 79.4399 178.66 79.6699 177.34C80.8199 178.04 81.9899 178.68 83.1899 179.24C83.7899 179.53 84.3999 179.8 85.0199 180.03C87.6299 181.1 90.3399 181.8 93.1599 182.03H93.1499Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M90.7998 189.32V189.3"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M79.6602 177.34V177.33"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M78.4299 181.16H78.4199V181.17"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M183.7 162.09C183.61 162.37 183.43 162.62 183.19 162.81C182.95 162.99 182.65 163.09 182.35 163.1C171.79 163.09 163.04 162.97 154.61 162.96C154.49 162.96 154.36 162.95 154.23 162.92C154.15 162.9 154.07 162.88 153.99 162.85C153.95 162.83 153.91 162.82 153.87 162.8C153.64 162.7 153.43 162.55 153.25 162.36C153.08 162.17 152.95 161.95 152.86 161.71C152.78 161.47 152.74 161.21 152.76 160.96C152.79 160.57 152.82 160.19 152.86 159.8C152.97 158.86 153.11 157.93 153.29 157C153.39 156.52 153.5 156.04 153.61 155.57C153.75 155.04 153.89 154.51 154.05 153.99C154.17 153.59 154.3 153.19 154.44 152.8C154.44 152.8 154.45 152.8 154.44 152.79C154.44 152.79 154.45 152.79 154.44 152.78H154.45V152.76C154.73 152.84 155.01 152.92 155.29 152.99C159.24 153.97 163.38 153.97 167.33 152.99C167.61 152.92 167.89 152.84 168.17 152.76C169.02 153.01 169.95 153.32 170.93 153.69C171.58 153.93 172.25 154.2 172.93 154.49C176.66 156.06 180.67 158.25 183.17 160.48C183.24 160.53 183.3 160.58 183.34 160.64C183.51 160.8 183.62 160.99 183.69 161.2C183.78 161.49 183.78 161.8 183.69 162.09H183.7Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M168.17 152.76C167.89 152.84 167.61 152.92 167.33 152.99C163.38 153.97 159.24 153.97 155.29 152.99C155.01 152.92 154.73 152.84 154.45 152.76L154.44 152.78C154.34 151.23 152.74 142.15 152.74 142.15C154.12 142.34 155.39 142.49 156.6 142.55C156.77 142.56 156.94 142.57 157.11 142.58C157.71 142.61 158.3 142.62 158.88 142.6C161.47 142.56 163.87 142.09 166.49 140.75L168.17 152.76Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M154.44 152.78C154.45 152.79 154.44 152.79 154.44 152.79C154.45 152.85 154.45 152.9 154.45 152.93"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M166.49 140.75V140.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M168.17 152.76V152.77L168.21 153.04"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M94.1001 206.23C93.1001 206.27 92.1101 206.27 91.1001 206.23H94.1001Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M163.54 34.24C163.96 35.45 163.91 36.76 163.4 37.94"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M173.35 27.02C173.01 27.94 172.64 28.73 172.38 29.39C170.18 33.88 167.6 38.16 164.69 42.21C163.59 39.47 157.77 35.67 154.6 35.7C154.77 35.27 154.8 34.79 154.69 34.34C154.57 33.88 154.31 33.47 153.95 33.16C152.13 31.64 149.3 29.6 150.05 28.79C151.25 27.51 154.73 30.13 156.78 29.93C157.92 29.82 161.95 22.26 162.36 21.54C163.92 18.79 165.54 19.34 164.49 22.35C163.91 24.06 163.22 25.75 162.45 27.38C162.27 27.66 162.07 27.96 161.86 28.32C161.53 28.86 161.15 29.5 160.65 30.31C159.51 32.14 161.55 33.76 162.76 32.07C163.49 31.04 164.04 30.26 164.58 29.45C164.58 29.45 164.59 29.47 164.6 29.47C164.07 30.26 163.59 31.06 163.12 31.88C162.47 32.93 162.86 33.91 163.54 34.23C164.05 34.47 164.71 34.36 165.23 33.64C166.01 32.55 166.57 31.73 167.14 30.87C167.19 30.91 167.24 30.95 167.29 30.99C168.92 29.65 170.35 28.03 171.5 26.26C173.55 22.7 174.6 23.61 173.35 27.02Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M167.29 30.99L167.27 31.01"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.69 42.21L164.68 42.22"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M162.45 27.38C162.45 27.38 162.44 27.41 162.43 27.43"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M154.6 35.7C154.6 35.7 154.59 35.72 154.59 35.73"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M168.15 31.71C167.85 31.46 167.57 31.21 167.29 30.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M167.14 30.87L167.13 30.86"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M160.12 27.99C160.71 28.07 161.3 28.18 161.88 28.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.95 28.89C164.83 29.08 164.7 29.26 164.58 29.45C164.04 30.26 163.49 31.04 162.76 32.07C161.55 33.76 159.51 32.14 160.65 30.31C161.15 29.5 161.53 28.86 161.86 28.32C162.07 27.96 162.27 27.66 162.45 27.38C162.58 27.2 162.7 27.03 162.83 26.87C163.89 25.53 166.08 27.17 164.95 28.89Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M167.42 30.46C167.33 30.6 167.23 30.74 167.14 30.87C166.57 31.73 166.01 32.55 165.23 33.64C164.71 34.36 164.05 34.47 163.54 34.24C162.86 33.91 162.47 32.93 163.12 31.88C163.59 31.06 164.07 30.26 164.6 29.47C164.82 29.12 165.06 28.78 165.3 28.44C166.38 27.11 168.55 28.74 167.42 30.46Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M54.72 55.68C56.84 56.69 58.31 54.28 56.34 53.16C54.87 52.33 53.8 51.78 52.61 51.19C50.61 50.18 49.13 52.78 50.71 53.76C51.65 54.35 52.78 54.75 54.72 55.68Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M53.5598 58.74C55.6298 59.67 57.0098 57.29 55.0798 56.27C53.6298 55.51 52.5798 55.02 51.4198 54.46C49.4598 53.53 48.0798 56.08 49.6398 56.98C50.5798 57.52 51.6598 57.88 53.5598 58.74Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.4298 49.41C55.6698 49.01 54.9798 48.67 54.2498 48.27C52.2498 47.18 50.6898 49.78 52.2498 50.84C53.5498 51.6 54.8898 52.3 56.2598 52.93C56.5398 53.1 56.8698 53.17 57.1898 53.14C57.5198 53.11 57.8198 52.97 58.0598 52.76C58.2998 52.54 58.4698 52.25 58.5298 51.93C58.5898 51.61 58.5498 51.28 58.4098 50.98"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M67.9698 54.94C66.1998 54.03 65.7198 51.14 64.9998 49.52C64.3198 47.97 63.7798 47.87 61.2698 46.62C58.2698 45.13 58.4598 45.53 55.9298 50.42C55.3398 51.56 57.0898 53.08 59.8498 49.42L59.7298 49.59C57.8298 52.25 58.0398 54.93 59.6098 56.67"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M66.1899 52.73C66.6899 52.43 67.0899 52.4 67.3799 52.56L67.4399 52.59"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M62.64 65.33H62.63C62.58 65.38 62.53 65.43 62.48 65.47"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.22 66.27C60.22 66.27 60.21 66.27 60.2 66.27C60.19 66.27 60.17 66.27 60.16 66.26C59.7 66.02 59.56 65.37 59.68 64.46C59.71 64.26 59.75 64.04 59.79 63.82C59.8 63.81 59.8 63.8 59.8 63.79"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M126.8 110.18C123.94 117.85 120.95 125.47 117.83 133.03C117.27 134.38 116.71 135.73 116.13 137.09C115.44 138.75 114.74 140.41 114.02 142.07C113.56 143.15 113.09 144.23 112.62 145.3C112.02 146.69 111.41 148.07 110.8 149.44C110.24 150.72 109.67 151.99 109.1 153.25C108.28 155.07 107.46 156.88 106.62 158.68C106.04 159.96 105.44 161.24 104.84 162.51C104.14 164.02 103.43 165.52 102.71 167.02C101.61 169.33 100.5 171.64 99.3802 173.93C98.0402 176.66 96.6802 179.37 95.3102 182.08C92.2202 182.08 89.2302 181.54 86.3202 180.52C86.2602 180.49 86.1902 180.47 86.1202 180.45C85.9902 180.4 85.8502 180.35 85.7202 180.3C85.4802 180.21 85.2502 180.12 85.0102 180.03C84.4002 179.78 83.7802 179.51 83.1802 179.22C81.2402 178.3 79.3502 177.18 77.4902 175.86C77.4902 175.86 77.4902 175.85 77.4702 175.85C86.9702 155.38 95.4002 135.98 101.48 118.85C101.51 117.6 101.61 116.36 101.78 115.13C101.86 114.51 101.96 113.89 102.08 113.28C102.13 112.97 102.19 112.67 102.26 112.37C102.35 111.9 102.46 111.43 102.58 110.97C102.8 110.04 103.06 109.14 103.34 108.26C103.47 107.82 103.62 107.39 103.77 106.97C103.88 106.65 103.99 106.33 104.11 106.03C104.22 105.74 104.33 105.45 104.44 105.17C104.54 104.9 104.65 104.65 104.76 104.39C106.37 100.55 108.24 97.64 109.57 96.47H109.58L108.67 88.86V88.81"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M108.33 86.03V85.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M67.4399 52.59L67.3799 52.56"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M117.56 66.96H117.62C118.39 67.01 119.29 67 120.15 66.82"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M119.66 55.07L119.57 54.95"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.15 66.82V66.79C119.31 66.96 118.44 67 117.59 66.94C117.6 66.94 117.61 66.96 117.62 66.96C118.52 67.74 119.5 68.43 120.54 69.01C120.81 69.64 121.27 70.18 122.05 70.2C122.43 73.61 117.07 74.4 114.03 71.11C114.44 70.94 114.73 70.69 114.9 70.33C115.16 69.21 115.12 68.04 114.82 66.94C114.82 66.92 114.81 66.91 114.81 66.89C114.71 66.38 114.6 65.87 114.46 65.36C114.33 64.83 114.17 64.31 114 63.8C113.06 63.48 112.37 63.05 111.9 62.58C111.76 62.44 111.64 62.3 111.53 62.17C111.35 61.93 111.22 61.68 111.13 61.45C111.02 61.13 110.98 60.83 111.02 60.57C111.04 60.44 111.08 60.31 111.14 60.21C111.17 60.15 111.2 60.1 111.24 60.06C111.53 59.73 112.07 59.65 112.77 60.06C112.98 60.18 113.18 60.29 113.36 60.36C113.62 60.46 113.79 60.48 113.91 60.42C113.94 60.42 113.97 60.4 113.99 60.37C114.01 60.36 114.03 60.34 114.04 60.32C114.06 60.29 114.08 60.27 114.08 60.23C114.09 60.21 114.1 60.19 114.1 60.16C114.11 60.14 114.12 60.12 114.11 60.09C114.11 60.04 114.11 59.99 114.11 59.93C114.11 59.88 114.11 59.83 114.11 59.78C114.02 59.13 114.04 58.36 114.17 57.59C114.25 57.13 114.37 56.66 114.53 56.23C114.68 55.79 114.88 55.37 115.1 55C115.25 54.76 115.42 54.54 115.59 54.34C116.58 53.27 117.98 53.1 119.66 55.06C120.18 55.73 120.86 56.69 121.25 57.4C124.92 64.19 122.77 66.27 120.15 66.81V66.82Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.15 66.82C120.15 66.91 120.15 67.11 120.18 67.37V67.39C120.21 67.84 120.31 68.47 120.54 69.01"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.82 81.17L115.52 82.31C115.48 81.84 115.41 81.32 115.34 80.76C114.98 77.58 114.34 74.44 113.45 71.35H113.44C112.29 71.53 111.13 71.4 109.99 71.16C109.99 71.16 109.99 71.18 110 71.22C110 71.22 110.01 71.29 110.03 71.34C110.04 71.39 110.05 71.46 110.08 71.54V71.56C110.13 71.78 110.21 72.1 110.31 72.5C110.43 73.01 110.57 73.66 110.73 74.4C110.79 74.69 110.85 74.98 110.92 75.29C110.99 75.67 111.06 76.06 111.14 76.46C111.19 76.75 111.25 77.04 111.3 77.34C111.42 78.04 111.54 78.78 111.64 79.52C111.72 80.07 111.79 80.63 111.85 81.18C111.89 81.55 111.92 81.92 111.95 82.28C111.97 82.55 111.99 82.82 112 83.09C112.01 83.22 112.02 83.35 112.02 83.48C112.03 83.61 112.03 83.74 112.03 83.87C112.04 84.29 112.03 84.7 112.02 85.08C112.02 85.17 112.01 85.26 112.01 85.35C112 85.57 111.98 85.78 111.96 85.98C111.93 86.22 111.9 86.45 111.87 86.67C111.82 86.93 111.76 87.17 111.7 87.39C111.66 87.52 111.61 87.64 111.57 87.76C111.53 87.87 111.48 87.98 111.44 88.07C110.92 89.07 110.05 89.45 108.67 88.81L108.33 86.03C103.44 85.02 87.0102 80.92 60.2202 66.27C60.7302 66.49 61.4202 66.25 62.1802 65.69C62.2802 65.63 62.3802 65.55 62.4802 65.47C62.5302 65.44 62.5902 65.39 62.6502 65.34C62.6502 65.34 62.6402 65.34 62.6402 65.33C64.9402 63.36 67.6602 58.86 67.9702 54.94C67.9902 54.72 68.0002 54.51 68.0002 54.3C68.0102 53.48 67.8202 52.85 67.4402 52.59C87.9802 63.45 95.0302 66.87 104.81 69.86C108.49 70.97 112.27 71.85 114.03 71.11C117.07 74.4 122.43 73.61 122.05 70.2C122.55 70.23 123.2 70.04 124.02 69.52C124.32 69.33 124.8 68.98 125.44 68.47C125.45 68.49 125.46 68.52 125.47 68.54C124.67 69.27 123.74 69.85 122.72 70.22C122.9 70.66 123.08 71.1 123.24 71.55C123.48 72.18 123.7 72.81 123.91 73.45C123.91 73.46 123.92 73.47 123.92 73.48C124.75 75.99 125.39 78.56 125.82 81.17Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.54 43.99C156.37 57.17 143.45 71.73 130.03 84.42C130.03 84.38 130.02 84.33 130.01 84.28C129.83 82.53 129.5 80.67 128.99 78.63C128.17 75.15 127.01 71.76 125.52 68.5C125.5 68.5 125.49 68.53 125.47 68.54C125.46 68.52 125.45 68.49 125.44 68.47C130.38 64.58 144.43 51.71 152.98 36.32C153.34 35.9 153.91 35.71 154.6 35.7C157.77 35.67 163.59 39.47 164.69 42.21C164.97 42.9 164.96 43.51 164.54 43.99Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M125.44 68.47C125.44 68.47 125.43 68.45 125.43 68.44"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M128.99 78.63C128.25 75.7 127.12 72.4 125.47 68.54"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M124.93 115.24C132.18 116.12 139.51 115.99 146.73 114.84V114.86C147.51 122.92 149.06 131.55 151.07 141.91C151.64 142 152.2 141.97 152.74 142.04C154.12 142.23 155.39 142.46 156.6 142.55"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M166.49 140.75C166.98 140.5 167.47 140.22 167.98 139.91L164.35 106.57C164.09 104.23 163.03 102.06 161.35 100.4C159.67 98.75 157.48 97.73 155.14 97.5L129.77 94.39C129.97 92.81 130.12 91.27 130.19 89.7C130.22 88.93 130.23 88.15 130.21 87.36C130.2 86.76 130.17 86.16 130.13 85.54C130.13 85.39 130.11 85.24 130.09 85.08L130.03 84.42"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M119.84 55.27C119.78 55.2 119.73 55.13 119.66 55.07C117.98 53.11 116.58 53.28 115.59 54.35C115.42 54.55 115.25 54.77 115.1 55.01C114.88 55.38 114.68 55.8 114.53 56.24C114.37 56.67 114.25 57.14 114.17 57.6C114.04 58.37 114.02 59.14 114.11 59.79C114.11 59.84 114.11 59.89 114.11 59.94C114.12 60.12 114.11 60.24 114.03 60.33C114.02 60.35 114 60.37 113.98 60.38C113.96 60.41 113.93 60.42 113.9 60.43C113.77 60.48 113.58 60.45 113.35 60.37C113.17 60.3 112.97 60.19 112.76 60.07C112.06 59.65 111.52 59.73 111.23 60.07C110.87 60.5 110.9 61.35 111.52 62.18C111.63 62.31 111.75 62.45 111.89 62.59C112.36 63.06 113.05 63.49 113.99 63.81C114.16 64.32 114.32 64.84 114.45 65.37C114.59 65.88 114.7 66.39 114.8 66.9C114.8 66.92 114.81 66.93 114.81 66.95C114.8 66.92 114.79 66.89 114.78 66.86C114.71 66.64 114.62 66.44 114.52 66.25C114.36 65.93 114.16 65.66 113.94 65.43C111.97 63.39 107.99 64.51 105.36 65.36C105.08 65.45 104.82 65.54 104.57 65.62C104.2 65.74 103.88 65.84 103.61 65.92C102 66.38 100.75 66.68 100.16 66.2C100.09 66.14 100.03 66.07 99.9801 65.99C99.9201 65.9 99.8801 65.79 99.8401 65.68C99.7901 65.48 99.7901 65.26 99.8301 65.02C99.8601 64.81 99.9301 64.59 100.04 64.37C100.2 64.04 100.45 63.7 100.78 63.38C101 63.17 101.25 62.97 101.54 62.78H101.55C102.01 62.5 102.5 62.26 103.03 62.08C101.95 62.43 101.05 62.37 100.71 61.83C100.53 61.54 100.55 61.1 100.73 60.63C100.92 60.12 101.3 59.57 101.8 59.08C102.06 58.83 102.34 58.6 102.66 58.39C102.72 58.36 102.86 58.28 102.99 58.2L103.19 58.09C103.19 58.09 103.24 58.06 103.27 58.05C103.29 58.04 103.31 58.03 103.32 58.02H103.31C102.42 58.24 101.83 58.14 101.51 57.85C100.93 57.33 101.21 56.2 102.16 55.22C102.23 55.14 102.3 55.07 102.38 55C102.83 54.59 103.41 54.21 104.09 53.93C104.32 53.83 104.56 53.74 104.78 53.65C105.24 53.48 105.67 53.32 106.1 53.16C110.57 51.62 113.57 51.59 115.63 52.19C116.02 52.3 116.37 52.44 116.7 52.59C116.97 52.71 117.21 52.84 117.44 52.98C118.05 53.36 118.54 53.79 118.94 54.21C119.12 54.4 119.28 54.59 119.43 54.77C119.58 54.95 119.71 55.12 119.83 55.28L119.84 55.27Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M122.05 70.2V70.18"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M114.03 71.11L114 71.08"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M108.67 88.81H108.66"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M112.03 83.87C112.04 84.28 112.04 84.69 112.03 85.08"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110 71.22H109.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M123.91 73.45C123.51 72.52 123.06 71.65 122.51 70.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M123.92 73.48C124.59 75.06 125.13 76.81 125.83 81.17H125.82"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M115.34 80.76C114.8 77.05 113.56 71.84 113.44 71.35C113.43 71.32 113.43 71.31 113.43 71.31"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M60.1802 66.25C60.1802 66.25 60.1902 66.26 60.2002 66.26C60.2102 66.26 60.2102 66.26 60.2202 66.26"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M109.87 86.32C109.87 86.32 109.31 86.23 108.33 86.03"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M58.6899 33.85L67.9499 30.86L69.3999 40.48"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M43.25 68.67L50.42 57.7"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M126.78 93.32L122.08 95.82L116.59 94.39L115.93 85.48L126.45 84.46L126.78 93.32Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M109.11 106.41C110.68 106.57 112.27 106.35 113.75 105.78C115.22 105.21 116.54 104.29 117.59 103.11"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M114.02 105.65L83.1699 179.25"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M157.11 142.6L152.74 108.88"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M152.74 108.88C144.07 109.97 135.38 110.54 127.52 109.54"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M120.58 69.03C120.58 69.03 120.55 69.02 120.54 69.01C119.5 68.43 118.52 67.74 117.62 66.96C117.62 66.96 117.6 66.95 117.59 66.94C118.44 67 119.31 66.96 120.15 66.79V66.82C120.15 67 120.16 67.18 120.18 67.37V67.39C120.23 67.95 120.37 68.5 120.58 69.03Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.63 29.49C164.63 29.49 164.61 29.48 164.6 29.47"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M164.58 29.45H164.55"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.9798 46.61C57.2698 46.18 56.7398 45.88 56.0798 45.49C54.2198 44.41 52.6598 46.96 54.1098 47.99C54.8698 48.5 55.6598 48.96 56.4898 49.37"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M50.0098 57.2C50.1398 57.37 50.2798 57.54 50.4098 57.71C52.7098 60.58 55.1698 62.82 59.1398 63.51C59.3598 63.61 59.5798 63.7 59.7898 63.81H59.7998C60.1798 63.99 60.5598 64.17 60.9298 64.37C61.5098 64.67 62.0798 64.99 62.6298 65.33H62.6398"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.7598 46.46L67.9498 30.86"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.5903 233.87V99.59"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.4702 111.87L22.5902 99.47L32.6802 111.87"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M22.5903 233.87V99.59"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.4702 111.87L22.5902 99.47L32.6802 111.87"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M238.19 233.87H213.09H78.8498H61.5798H40.9698H22.5898"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M225.79 223.76L238.19 233.88L225.79 243.97"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.21 168.28V233.87H154.59V168.28C154.59 167.6 154.72 166.92 154.98 166.3C155.24 165.67 155.62 165.1 156.11 164.62C156.59 164.13 157.16 163.75 157.79 163.49C158.41 163.23 159.09 163.1 159.77 163.1H170.03C170.71 163.1 171.38 163.23 172.01 163.49C172.64 163.75 173.21 164.13 173.69 164.62C174.17 165.1 174.55 165.67 174.81 166.3C175.07 166.92 175.21 167.6 175.21 168.28Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M175.21 168.28V233.87H154.59V168.28C154.59 167.6 154.72 166.92 154.98 166.3C155.24 165.67 155.62 165.1 156.11 164.62C156.59 164.13 157.16 163.75 157.79 163.49C158.41 163.23 159.09 163.1 159.77 163.1H170.03C170.71 163.1 171.38 163.23 172.01 163.49C172.64 163.75 173.21 164.13 173.69 164.62C174.17 165.1 174.55 165.67 174.81 166.3C175.07 166.92 175.21 167.6 175.21 168.28Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M132.12 190.41H121.88C121.2 190.41 120.53 190.54 119.9 190.8C119.27 191.06 118.7 191.44 118.22 191.92C117.74 192.4 117.36 192.97 117.1 193.6C116.84 194.23 116.71 194.9 116.71 195.58V233.87H137.33V195.58C137.33 194.9 137.2 194.22 136.94 193.59C136.68 192.96 136.3 192.38 135.81 191.9C135.32 191.42 134.75 191.04 134.12 190.78C133.49 190.52 132.81 190.39 132.12 190.4V190.41Z"
        fill="#F3123C"
      />
      <Path
        d="M137.33 233.88V195.57C137.33 194.89 137.2 194.22 136.94 193.59C136.68 192.96 136.3 192.39 135.82 191.91C135.34 191.43 134.77 191.05 134.14 190.79C133.51 190.53 132.84 190.4 132.16 190.4H121.89C121.21 190.4 120.54 190.53 119.91 190.79C119.28 191.05 118.71 191.43 118.23 191.91C117.75 192.39 117.37 192.96 117.11 193.59C116.85 194.22 116.72 194.89 116.72 195.57V233.88"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M132.12 190.41H121.88C121.2 190.41 120.53 190.54 119.9 190.8C119.27 191.06 118.7 191.44 118.22 191.92C117.74 192.4 117.36 192.97 117.1 193.6C116.84 194.23 116.71 194.9 116.71 195.58V233.87H137.33V195.58C137.33 194.9 137.2 194.22 136.94 193.59C136.68 192.96 136.3 192.38 135.81 191.9C135.32 191.42 134.75 191.04 134.12 190.78C133.49 190.52 132.81 190.39 132.12 190.4V190.41Z"
        fill="#F3123C"
      />
      <Path
        d="M137.33 233.88V195.57C137.33 194.89 137.2 194.22 136.94 193.59C136.68 192.96 136.3 192.39 135.82 191.91C135.34 191.43 134.77 191.05 134.14 190.79C133.51 190.53 132.84 190.4 132.16 190.4H121.89C121.21 190.4 120.54 190.53 119.91 190.79C119.28 191.05 118.71 191.43 118.23 191.91C117.75 192.39 117.37 192.96 117.11 193.59C116.85 194.22 116.72 194.89 116.72 195.57V233.88"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M99.4701 211.41V233.87H78.8501V211.41C78.8501 210.73 78.9801 210.05 79.2501 209.43C79.5101 208.8 79.8901 208.23 80.3701 207.75C80.8501 207.26 81.4201 206.88 82.0501 206.62C82.6801 206.36 83.3501 206.23 84.0301 206.23H91.1001C92.1101 206.27 93.1001 206.27 94.1001 206.23H94.2901C94.9701 206.23 95.6401 206.36 96.2701 206.62C96.9001 206.88 97.4701 207.26 97.9501 207.75C98.4301 208.23 98.8101 208.8 99.0701 209.43C99.3301 210.05 99.4701 210.73 99.4701 211.41Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M99.4701 211.41V233.87H78.8501V211.41C78.8501 210.73 78.9801 210.05 79.2501 209.43C79.5101 208.8 79.8901 208.23 80.3701 207.75C80.8501 207.26 81.4201 206.88 82.0501 206.62C82.6801 206.36 83.3501 206.23 84.0301 206.23H91.1001C92.1101 206.27 93.1001 206.27 94.1001 206.23H94.2901C94.9701 206.23 95.6401 206.36 96.2701 206.62C96.9001 206.88 97.4701 207.26 97.9501 207.75C98.4301 208.23 98.8101 208.8 99.0701 209.43C99.3301 210.05 99.4701 210.73 99.4701 211.41Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.3802 217.99H46.1402C45.4602 217.99 44.7902 218.12 44.1602 218.38C43.5302 218.64 42.9602 219.02 42.4802 219.5C42.0002 219.98 41.6202 220.55 41.3602 221.18C41.1002 221.81 40.9702 222.48 40.9702 223.16V233.87H61.5802V223.16C61.5802 222.48 61.4502 221.8 61.1902 221.17C60.9302 220.54 60.5502 219.97 60.0602 219.49C59.5802 219.01 59.0002 218.63 58.3702 218.37C57.7402 218.11 57.0602 217.98 56.3802 217.99Z"
        fill="#F3123C"
      />
      <Path
        d="M61.58 233.88V223.14C61.58 222.46 61.45 221.79 61.19 221.16C60.93 220.53 60.55 219.96 60.07 219.48C59.59 219 59.02 218.62 58.39 218.36C57.76 218.1 57.09 217.97 56.41 217.97H46.15C45.47 217.97 44.8 218.1 44.17 218.36C43.54 218.62 42.97 219 42.49 219.48C42.01 219.96 41.63 220.53 41.37 221.16C41.11 221.79 40.98 222.46 40.98 223.14V233.88"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M56.3802 217.99H46.1402C45.4602 217.99 44.7902 218.12 44.1602 218.38C43.5302 218.64 42.9602 219.02 42.4802 219.5C42.0002 219.98 41.6202 220.55 41.3602 221.18C41.1002 221.81 40.9702 222.48 40.9702 223.16V233.87H61.5802V223.16C61.5802 222.48 61.4502 221.8 61.1902 221.17C60.9302 220.54 60.5502 219.97 60.0602 219.49C59.5802 219.01 59.0002 218.63 58.3702 218.37C57.7402 218.11 57.0602 217.98 56.3802 217.99Z"
        fill="#F3123C"
      />
      <Path
        d="M61.58 233.88V223.14C61.58 222.46 61.45 221.79 61.19 221.16C60.93 220.53 60.55 219.96 60.07 219.48C59.59 219 59.02 218.62 58.39 218.36C57.76 218.1 57.09 217.97 56.41 217.97H46.15C45.47 217.97 44.8 218.1 44.17 218.36C43.54 218.62 42.97 219 42.49 219.48C42.01 219.96 41.63 220.53 41.37 221.16C41.11 221.79 40.98 222.46 40.98 223.14V233.88"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M201.38 71.28C201.38 72.21 201.11 73.12 200.6 73.9C200.09 74.68 199.36 75.28 198.5 75.64C197.64 76 196.7 76.1 195.79 75.92C194.88 75.74 194.04 75.3 193.37 74.65C192.71 74 192.26 73.16 192.07 72.25C191.88 71.34 191.97 70.39 192.32 69.53C192.67 68.67 193.27 67.93 194.04 67.41C194.81 66.89 195.72 66.61 196.65 66.6C197.27 66.6 197.88 66.71 198.45 66.95C199.02 67.18 199.54 67.53 199.98 67.96C200.42 68.39 200.77 68.91 201.01 69.48C201.25 70.05 201.37 70.66 201.37 71.28H201.38Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M213.61 83.18C213.61 84.11 213.34 85.02 212.83 85.8C212.32 86.58 211.59 87.18 210.73 87.54C209.87 87.9 208.93 88 208.02 87.82C207.11 87.64 206.27 87.2 205.6 86.55C204.94 85.9 204.49 85.06 204.3 84.15C204.11 83.24 204.2 82.29 204.55 81.43C204.9 80.57 205.5 79.83 206.27 79.31C207.04 78.79 207.95 78.51 208.88 78.5C209.5 78.5 210.11 78.61 210.68 78.85C211.25 79.08 211.77 79.43 212.21 79.86C212.65 80.29 213 80.81 213.24 81.38C213.48 81.95 213.6 82.56 213.61 83.18V83.18Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M192.07 88.03L213.52 66.32"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M51.27 134.93V146.81"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.2203 140.87H45.3403"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M115.07 8.42001H109.19C108.84 8.42001 108.5 8.47001 108.17 8.60001C107.85 8.73001 107.55 8.92001 107.31 9.16001C107.06 9.40001 106.87 9.69001 106.73 10.01C106.6 10.33 106.53 10.67 106.53 11.02C106.53 11.37 106.6 11.71 106.74 12.03C106.88 12.35 107.08 12.64 107.33 12.88C107.58 13.12 107.88 13.31 108.2 13.43C108.52 13.55 108.87 13.61 109.22 13.6H112.47C112.82 13.6 113.16 13.65 113.48 13.78C113.8 13.91 114.1 14.1 114.34 14.34C114.58 14.58 114.78 14.87 114.92 15.19C115.06 15.51 115.13 15.85 115.13 16.2C115.13 16.55 115.06 16.89 114.93 17.21C114.8 17.53 114.6 17.82 114.35 18.06C114.1 18.3 113.81 18.49 113.49 18.62C113.17 18.75 112.82 18.81 112.48 18.8H106.63"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110.83 6.47V20.74"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M234.03 115.82C234.03 116.22 233.91 116.62 233.69 116.96C233.46 117.3 233.15 117.56 232.77 117.71C232.4 117.86 231.99 117.9 231.59 117.83C231.19 117.75 230.83 117.56 230.55 117.27C230.26 116.98 230.07 116.62 229.99 116.23C229.91 115.83 229.95 115.42 230.11 115.05C230.26 114.68 230.53 114.36 230.86 114.13C231.2 113.9 231.59 113.79 231.99 113.79C232.53 113.79 233.05 114 233.43 114.39C233.81 114.77 234.03 115.29 234.03 115.83V115.82Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.4601 71.21C17.4601 71.54 17.3601 71.86 17.1801 72.13C17.0001 72.4 16.7401 72.62 16.4301 72.74C16.1301 72.87 15.7901 72.9 15.4701 72.83C15.1501 72.77 14.8501 72.61 14.6201 72.37C14.3901 72.13 14.2301 71.84 14.1701 71.52C14.1101 71.2 14.1401 70.86 14.2601 70.56C14.3901 70.26 14.6001 70 14.8701 69.81C15.1401 69.63 15.4601 69.53 15.7901 69.53C16.0101 69.53 16.2301 69.57 16.4301 69.65C16.6301 69.73 16.8201 69.86 16.9701 70.01C17.1201 70.16 17.2501 70.35 17.3301 70.55C17.4101 70.75 17.4601 70.97 17.4501 71.19L17.4601 71.21Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8483_162493">
        <Rect width={226.66} height={238.44} fill="white" transform="translate(12 6)" />
      </ClipPath>
    </Defs>
  </Svg>
))
